import React from 'react';
import Hero from '../components/Hero/Hero';
import Header from '../components/Header/Header';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Gallery from '../components/Gallery/Gallery';
import Team from '../components/Team/Team';
import Testimonial from '../components/Testimonial/Testimonial';

const Home = () => {
  return (
    <div className="page-wrapper">
      {/* Hero Section with Header Overlay */}
      <div className="home-hero-wrapper">
        <Header />
        <Hero />
      </div>

      {/* About Section */}
      <About />

      {/* Services Section */}
      <Services />

      {/* Gallery Section */}
      <Gallery />

      {/* Team Section */}
      <Team />

      {/* Testimonial Section */}
      <Testimonial />
    </div>
  );
};

export default Home;
